class Bestprice {
	static select = $context => $context.select('.bestprice');

	constructor($bestprice) {
		this.$bestprice = $bestprice;

		this.init();
		this.bindEvents();
	}

	init() {
		Update(this.$bestprice.find('.formgroup'));
	}

	bindEvents() {
		const self = this;
		self.$form = self.$bestprice.find('.bestprice__form');
		self.$content = self.$bestprice.find('.bestprice__inner');
		self.$loading = self.$bestprice.find('.bestprice__loading');
		self.$btnSubmit = self.$bestprice.find('.bestprice__btn-submit');
		self.$btnReturn = self.$bestprice.find('.bestprice__btn-return');

		self.$btnReturn.on('click', function(){
			ModalUtil.close();
		});

		self.$btnSubmit.on('click', function(){
			self.$form.submit();
		});

		self.$form.on('submit', (e) => {
			e.preventDefault();
			self.$loading.show();
			const data = self.$form.serialize();

			$.post(self.$form.data('url'), data, function (response) {
				const $response = $('<div></div>').html(response);
				const $content = $response.find('.bestprice__inner');
				self.$content.replaceWith($content);
			}).fail(function (error) {
				console.log(error);
			})
			.always(function () {
				self.$loading.hide();
				self.init();
				self.bindEvents();
			});
		});
	}

}

export default () => Component(Bestprice.select, $bestprice => new Bestprice($bestprice));
